var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-card-list-container",attrs:{"id":_vm.markId}},[_c('el-collapse',{class:_vm.className,attrs:{"accordion":_vm.accordion},on:{"change":_vm.change},model:{value:(_vm.curCollapse),callback:function ($$v) {_vm.curCollapse=$$v},expression:"curCollapse"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }